// extracted by css-extract-rspack-plugin
export default {"fitImage":"ocqn3"};